import { InfoCircleOutlined } from "@ant-design/icons";
import { Table, Tag, Pagination, Avatar, Popover } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from "../modal/ConfirmationModal";
import EditUserModal from "../modal/edit/EditUserModal";
import InfoUserModal from "../modal/InfoUserModal";
import { LIMIT_PER_PAGE } from "../../helpers/constants";
import { useSelector } from "react-redux";
import { getPluralString } from "../../helpers/wordHelpers";

function PositionsPerformanceTable(props) {
  const [infoModal, setInfoModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const topPlanState = useSelector((state) => state.topPlanState.value);
  let navigate = useNavigate();
  useEffect(() => {
    setLoading(props.loading);
  }, [props.loading]);

  useEffect(() => {
    setPage(props.page);
  }, [props.page]);

  const columns = [
    {
      title: "Designation",
      dataIndex: "designations",
      key: "designations",
      render: (text, record) => <div>{record.designations?.abbreviation}</div>,
    },
    {
      title: "Unit",
      dataIndex: "units",
      key: "units",
      render: (text, record) => (
        <>
          <div className="flex items-center gap-1">
            <div
              className="w-2 h-2 mr-1 rounded-full"
              style={{
                backgroundColor: record.units?.organizationLevel?.color,
              }}
            />
            <div>{record.units?.name}</div>
            <Popover
              placement="top"
              content={
                <div className="text-xs">
                  {record.units?.name +
                    (record.units?.headUnit
                      ? " < " + record.units?.headUnit?.name
                      : "")}
                  {record.units?.headUnit?.headUnit &&
                    " < " + record.units?.headUnit?.headUnit?.name}
                </div>
              }
              trigger="hover"
            >
              <div className="text-gray-500 text-xs ml-1">
                <InfoCircleOutlined />
              </div>
            </Popover>
          </div>
        </>
      ),
    },
    {
      title: "Role",
      key: "userRole",
      dataIndex: "userRole",
      render: (text, record) => <div>{record.userRole.name}</div>,
    },
    {
      title: "User",
      key: "users",
      dataIndex: "users",
      render: (text, record) => (
        <div className="flex items-center">
          {record.users?.id ? (
            record.users?.status !== "Invited" &&
            record.users?.status !== "Pending" ? (
              <div className="flex items-center">
                {record.users?.imageUrl ? (
                  <Avatar src={record.users?.imageUrl} />
                ) : (
                  <Avatar>
                    {record.users?.firstName?.charAt(0).toUpperCase()}
                  </Avatar>
                )}
                <div className="mx-1">
                  <div className="max-w-xs truncate overflow-hidden">
                    {record.users?.firstName + " " + record.users?.lastName}
                  </div>
                </div>
              </div>
            ) : (
              <div className="max-w-xs truncate overflow-hidden mr-1">
                {record.users?.email}
              </div>
            )
          ) : (
            "-"
          )}
        </div>
      ),
    },
    {
      title: getPluralString(topPlanState),
      key: "plansCount",
      dataIndex: "plansCount",
      render: (text, record) => <div>{record.plansCount}</div>,
    },

    {
      title: "Performance",
      dataIndex: "performance",
      key: "performance",
      render: (text, record) => (
        <Tag
          color={
            record.status === "off"
              ? "Orange"
              : record.status === "risk"
              ? "Red"
              : "Green"
          }
        >
          {record.performance}
        </Tag>
      ),
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={props.data?.positions}
        pagination={false}
        loading={loading}
        onRow={(record) => {
          return {
            onClick: () => {
              navigate(`/positions-performance/${record.id}`);
            },
          };
        }}
        rowClassName={"cursor-pointer hover:shadow"}
      />
      <div className="text-center mt-6">
        <Pagination
          onChange={(num) => props.changePage(num)}
          current={page}
          total={props.data?.totalCount || 0}
          pageSize={LIMIT_PER_PAGE}
        />
      </div>
      <ConfirmationModal
        visible={deleteModal}
        handleCancel={() => setDeleteModal(false)}
        text="Are you sure want to delete this user?"
        title="Delete user"
      />
      <EditUserModal
        visible={editModal}
        handleCancel={() => setEditModal(false)}
      />
      <InfoUserModal
        visible={infoModal}
        handleCancel={() => setInfoModal(false)}
      />
    </>
  );
}

export default PositionsPerformanceTable;
